var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3684 46H10",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6842 49.6846V49.6846C23.9749 49.6846 24.2105 49.9202 24.2105 50.2109V50.2109C24.2105 50.5016 23.9749 50.7372 23.6842 50.7372V50.7372C23.3935 50.7372 23.1579 50.5016 23.1579 50.2109V50.2109C23.1579 49.9202 23.3935 49.6846 23.6842 49.6846",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3684 37.5789V50.2105C37.3684 52.5359 35.4833 54.421 33.1579 54.421H14.2105C11.8851 54.421 10 52.5359 10 50.2105V10.2105C10 7.88512 11.8851 6 14.2105 6H25.7895",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5264 18.6312C42.2704 18.6312 43.6843 17.2174 43.6843 15.4733C43.6843 13.7293 42.2704 12.3154 40.5264 12.3154C38.7823 12.3154 37.3685 13.7293 37.3685 15.4733C37.3685 17.2174 38.7823 18.6312 40.5264 18.6312Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9999 15.4737C49.9999 21.7895 40.5262 31.2632 40.5262 31.2632C40.5262 31.2632 31.0525 21.7895 31.0525 15.4737C31.0525 10.2415 35.294 6 40.5262 6C45.7584 6 49.9999 10.2415 49.9999 15.4737Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTracking);
export default __webpack_public_path__ + "static/media/icon-tracking.67364ecb.svg";
export { ForwardRef as ReactComponent };